import { BannerButton } from '../types';

/** Choose prod/dev path and substitute the [username] placeholder. */
export const resolvePath = (
  navigatePath: string | undefined,
  devNavigatePath: string | undefined,
  isDev: boolean,
  username?: string,
): string | undefined => {
  let path = isDev ? devNavigatePath ?? navigatePath : navigatePath;
  if (path && username) path = path.replace('[username]', username);
  return path;
};

export const resolveButtonPath = (button: BannerButton, isDev: boolean, username?: string): string | undefined =>
  resolvePath(button.navigatePath, button.devNavigatePath, isDev, username);
